"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayout = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const constants_1 = require("./constants");
const Root = styled_components_1.default.div `
  height: 100%;
  min-width: ${constants_1.DASHBOARD_LAYOUT_WIDTHS.minWidth};
`;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-flow: row wrap;
  max-width: ${constants_1.DASHBOARD_LAYOUT_WIDTHS.maxWidth};

  > div {
    margin: 0 ${components_1.SPACING_M} ${components_1.SPACING_M} 0;

    flex-grow: 1;
    flex-basis: calc(33.33% - ${components_1.SPACING_M});

    :nth-child(3n) {
      margin-right: 0;
    }

    :nth-last-child(-n + 3) {
      margin-bottom: 0;
    }

    @media (max-width: ${constants_1.DASHBOARD_LAYOUT_WIDTHS.twoRows}) {
      flex-basis: calc(50% - ${components_1.SPACING_M});

      :nth-child(3n) {
        margin-right: ${components_1.SPACING_M};
      }

      :nth-child(even) {
        margin-right: 0;
      }
    }
  }
`;
const DashboardLayout = ({ children }) => {
    return (react_1.default.createElement(Root, null,
        react_1.default.createElement(Wrapper, null, children)));
};
exports.DashboardLayout = DashboardLayout;
//# sourceMappingURL=DashboardLayout.js.map